export default {
  // 信息列表
  async getInfoListAsync(context, payload) {
    if (context.state.infoList.status) {
      return Promise.resolve(1);
    }
    try {
      const res = await this.$http.post('/i/infolists.html', payload);
      if (res.data.status === 1) {
        context.commit('SET_INFO_LIST', res.data);
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
  async getInfoDetailAsync(context, payload) {
    try {
      const res = await this.$http.post('/i/infoDesc.html', payload);
      if (res.data.status === 1) {
        return Promise.resolve(res.data.data);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
};
